import { updatePaperStashAnswer } from '@/api/paperApi'

const state = {
    batchNo: null,
    // 配置
    config: {
        clientWidth: 0,
        clientHeight: 0,
        // tablet: 平板 mobile: 手机
        layout: 'mobile',
        headerHeight: 42,
    },
    // 试卷信息
    paperInfo: null,
    // 试题
    moduleList: [],
    // 收藏
    collectionMap: null,

    // 用户答题记录存储 state: true/false  q-{id}: [x,x]
    userAnswerMap: null,
    // 答题卡显示状态
    questionCardState: false,
    // 答题开始时间，记录时间戳  历史记录则减去已答题时间
    answerTime: { startTime: 0, endTime: 0 },

    // 当前显示试题 indexNo id
    currentQuestion: null,
    // 当前显示子题目  indexNo id
    currentSubQuestion: null,
    // {questionId: 0, subQuestionId: 0}
    jumpQuestion: null,

    complexTypes: ['LISTENING', 'EREADING_COMPREHENSION', 'COMPREHENSION', 'LISTENING_BLANK', 'LISTENING_MATCH', 'COMPREHENSION_MATCH'],
    listeningComplexTypes: ['LISTENING_BLANK', 'LISTENING_MATCH'],
}
const mutations = {
    updateBatchNo(state, data) {
        state.batchNo = data
    },
}

const actions = {
    setBatchNo({ state }, data) {
        state.batchNo = data
    },
    setConfig({ state }, data) {
        state.config.clientWidth = data.clientWidth
        state.config.clientHeight = data.clientHeight
        if (state.config.clientWidth >= 960) {
            state.config.layout = 'tablet'
            state.config.headerHeight = 45
        } else {
            state.config.layout = 'mobile'
            state.config.headerHeight = 42
        }
    },
    setPaperInfo({ state }, data) {
        state.paperInfo = data
    },
    setModuleList({ state }, data) {
        state.moduleList = data
    },
    setCollectionMap({ state }, data) {
        state.collectionMap = { ...state.collectionMap, ...data }
    },
    // 更新答题状态
    updateUserAnswer({ state, commit }, data) {
        // 答题暂存
        if (data.answer.join('')) {
            const duration = parseInt((state.answerTime.endTime - state.answerTime.startTime) / 1000)
            const params = {
                questionId: data.id,
                paperNo: state.paperInfo.paperNo,
                answer: data.answer.join('@@'),
                duration: duration > 0 ? duration : 0,
            }
            if (state.batchNo) params.batchNo = state.batchNo
            updatePaperStashAnswer(params).then((res) => {
                commit('updateBatchNo', res.data)
            })
        }
    },
    setUserAnswerMap({ state }, data) {
        state.userAnswerMap = { ...state.userAnswerMap, ...data }
    },
    setQuestionCardState({ state }, data) {
        state.questionCardState = data
    },
    setAnswerTime({ state }, data) {
        if (data.startTime) state.answerTime.startTime = data.startTime
        if (data.endTime) state.answerTime.endTime = data.endTime
    },
    setCurrentQuestion({ state }, data) {
        state.currentQuestion = data
    },
    setCurrentSubQuestion({ state }, data) {
        state.currentSubQuestion = data
    },
    setJumpQuestion({ state }, data) {
        state.jumpQuestion = data
        if (!data.currentSubQuestion) {
            state.currentSubQuestion = null
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
